import { BasicModal } from "@/ui-components/commonComponents/Modal/BasicModal";

import styles from "./style.module.css";

export interface RoleDefinition {
  name: string;
  description: string;
}

export function ViewRolesModal({
  isOpen,
  onClose,
  title,
  roles,
}: {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  roles: RoleDefinition[];
}) {
  return (
    <BasicModal isModalOpen={isOpen} handleCancel={onClose} autoHeight>
      <div className={styles.rolesModalContent}>
        <h2 className={styles.rolesModalTitle}>{title}</h2>
        <dl className={styles.rolesList}>
          {roles.map((role) => (
            <div key={role.name} className={styles.roleItem}>
              <dt>{role.name}</dt> <dd>{role.description}</dd>
            </div>
          ))}
        </dl>
      </div>
    </BasicModal>
  );
}
